import React from "react";
import theme from "theme";
import { Theme, Link, Image, Text, LinkBox, Box, Section, Icon, Strong, Em, Span } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { Override } from "@quarkly/components";
import * as Components from "components";
import { FiMenu } from "react-icons/fi";
import { AiOutlineMenu } from "react-icons/ai";
import { FaReceipt, FaFileInvoiceDollar, FaUserCheck, FaInstagram, FaLinkedin, FaFacebook } from "react-icons/fa";
import { MdDone } from "react-icons/md";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"index"} />
		<Helmet>
			<title>
				Home | Website Example
			</title>
			<meta name={"description"} content={"It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference."} />
			<meta property={"og:title"} content={"Home | Website Example"} />
			<meta property={"og:description"} content={"It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference."} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/website-example-quarkly.png?v=2020-11-05T19:48:01.806Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/68f7854bd788530023e19e81/images/balllogo.png?v=2025-10-25T15:24:36.353Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/68f7854bd788530023e19e81/images/balllogo.png?v=2025-10-25T15:24:36.353Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/68f7854bd788530023e19e81/images/balllogo.png?v=2025-10-25T15:24:36.353Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/68f7854bd788530023e19e81/images/balllogo.png?v=2025-10-25T15:24:36.353Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/68f7854bd788530023e19e81/images/balllogo.png?v=2025-10-25T15:24:36.353Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/68f7854bd788530023e19e81/images/balllogo.png?v=2025-10-25T15:24:36.353Z"} />
		</Helmet>
		<Section sm-padding="8px 0 8px 0" quarkly-title="Header-6" padding="24px 0px 24px 0px">
			<Override
				slot="SectionContent"
				flex-direction="row"
				justify-content="space-between"
				max-width="100%"
				width="100%"
				padding="0px 24px 0px 24px"
			/>
			<Components.QuarklycommunityKitMobileSidePanel
				menuPosition="full"
				breakpoint="lg"
				width="40%"
				sm-width="50%"
				md-width="50%"
				lg-width="40%"
				lg-justify-content="flex-start"
				md-justify-content="flex-end"
			>
				<Override slot="Children" md-display="flex" />
				<Override
					slot="Content"
					padding="0px 0px 0px 0px"
					background="rgba(255, 255, 255, 0)"
					lg-background="#ffffff"
					lg-margin="0px 0px 0px 0px"
				/>
				<Override
					slot="Button Text"
					font="normal 600 16px/1.5 -apple-system, system-ui, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
					text-transform="uppercase"
					letter-spacing="1px"
					sm-font="normal 600 14px/1.5 -apple-system, system-ui, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
					sm-margin="0px 2px 0px 0px"
					lg-margin="0px 0px 0px 0px"
				/>
				<Override
					slot="Button Icon :closed"
					category="fi"
					icon={FiMenu}
					size="32px"
					padding="5px 7px 5px 7px"
					border-radius="50px"
				/>
				<Override
					slot="Button Icon"
					width="28px"
					height="28px"
					category="ai"
					icon={AiOutlineMenu}
					color="--dark"
					size="24px"
					lg-width="32px"
					lg-height="32px"
				/>
				<Override
					slot="Cross"
					lg-width="32px"
					lg-height="32px"
					size="32px"
					top="24px"
					right="24px"
				/>
				<Link
					border-radius="8px"
					href="#about"
					text-decoration-line="initial"
					sm-padding="5px 10px 5px 10px"
					md-padding="5px 10px 5px 10px"
					sm-margin="10px 0px 10px 0px"
					font="--base"
					margin="0px 0px 0px 0px"
					md-margin="10px 0px 0px 0px"
					padding="6px 12px 7px 12px"
					color="#424242"
				>
					About
				</Link>
				<Link
					border-radius="8px"
					href="#features"
					text-decoration-line="initial"
					sm-padding="5px 10px 5px 10px"
					md-padding="5px 10px 5px 10px"
					sm-margin="10px 0px 10px 0px"
					font="--base"
					margin="0px 0px 0px 0px"
					md-margin="10px 0px 0px 0px"
					padding="6px 12px 7px 12px"
					color="#424242"
				>
					Features
				</Link>
				<Link
					border-radius="8px"
					href="#integrations"
					text-decoration-line="initial"
					sm-padding="5px 10px 5px 10px"
					md-padding="5px 10px 5px 10px"
					sm-margin="10px 0px 10px 0px"
					font="--base"
					margin="0px 0px 0px 0px"
					md-margin="10px 0px 0px 0px"
					padding="6px 12px 7px 12px"
					color="#424242"
				>
					Integrations
				</Link>
				<Link
					border-radius="8px"
					href="#pricing"
					text-decoration-line="initial"
					sm-padding="5px 10px 5px 10px"
					md-padding="5px 10px 5px 10px"
					sm-margin="10px 0px 10px 0px"
					font="--base"
					margin="0px 0px 0px 0px"
					md-margin="10px 0px 0px 0px"
					padding="6px 12px 7px 12px"
					color="#424242"
				>
					Pricing
				</Link>
			</Components.QuarklycommunityKitMobileSidePanel>
			<Box
				display="flex"
				padding="12px 0"
				justify-content="center"
				align-items="flex-start"
				flex-direction="row"
				width="20%"
				sm-width="50%"
				sm-align-items="center"
				sm-flex-direction="row"
				sm-justify-content="flex-start"
				md-width="50%"
				lg-width="20%"
				md-justify-content="flex-start"
				md-order="-1"
			>
				<LinkBox flex-direction="row" href="/index" display="flex" grid-gap="12px">
					<Image src="https://s3.eu-north-1.amazonaws.com/dayfive.eu/assets/img/ball_logo_balanced.png" display="block" width="36px" height="36px" />
					<Text
						margin="0"
						md-margin="0px 0 0px 0"
						text-align="left"
						font="--lead"
						sm-margin="0px 0 0px 0"
						display="block"
					>
						DayFive
					</Text>
				</LinkBox>
			</Box>
			<Box
				display="flex"
				padding="12px 0"
				justify-content="flex-end"
				align-items="flex-start"
				flex-direction="row"
				width="40%"
				sm-width="50%"
				sm-align-items="center"
				sm-flex-direction="row"
				sm-justify-content="flex-start"
				md-width="50%"
				lg-width="40%"
				md-justify-content="flex-start"
				md-display="none"
			>
				<Link
					border-radius="8px"
					href="https://app.dayfive.eu/login"
					text-decoration-line="initial"
					sm-padding="5px 10px 5px 10px"
					md-padding="5px 10px 5px 10px"
					sm-margin="10px 0px 10px 0px"
					font="--base"
					margin="0px 0px 0px 34px"
					md-margin="10px 0px 0px 0px"
					padding="6px 12px 7px 12px"
					border="2px solid #0097A788"
					color="#ffffff"
					background="#0097A7"
				>
					LOGIN
				</Link>
				<Link
					font="--base"
					text-decoration-line="initial"
					margin="0px 0px 0px 16px"
					background="#ffffff"
					border="2px solid #0097A7"
					border-radius="8px"
					md-margin="0px 0px 0px 14px"
					href="https://calendar.app.google/fQpVz66cTdDvWA7E8"
					color="#0097A7"
					padding="6px 12px 7px 12px"
					md-order="1"
				>
					Book A Demo
				</Link>
			</Box>
		</Section>
		<Section
			lg-padding="25px 0 25px 0"
			sm-padding="0px 0 25px 0"
			justify-content="center"
			sm-align-items="center"
			sm-justify-content="center"
			quarkly-title="Hero"
		>
			<Override
				slot="SectionContent"
				md-margin="0px 16px 0px 16px"
				width="100%"
				background="url(https://s3.eu-north-1.amazonaws.com/dayfive.eu/assets/img/landing_page.png)"
				height="620px"
				justify-content="center"
				sm-width="100%"
				min-width="auto"
				margin="0px 32px 0px 32px"
				align-items="center"
				lg-height="520px"
				md-height="420px"
				md-padding="0px 24px 0px 24px"
			/>
			<Text
				font="--headline1"
				margin="16px 0px 0px 0px"
				sm-text-align="center"
				sm-width="80%"
				lg-text-align="center"
				lg-font="--headline2"
				color="--light"
			>
				Tired of invoice Chaos?
			</Text>
			<Text
				sm-text-align="center"
				sm-width="80%"
				opacity="0.85"
				md-text-align="center"
				font="--lead"
				color="--light"
				margin="10px 0px 35px 0px"
			>
				Streamline purchasing, automate expense tracking and ensure every invoice is accounted for effortlessly.
			</Text>
			<Link
				text-decoration-line="initial"
				color="#ffffff"
				border-radius="12px"
				padding="12px 24px 12px 24px"
				letter-spacing="0.5px"
				transition="transform --transitionDuration-fast --transitionTimingFunction-easeInOut 0s"
				href="#features"
				background="#ffffff44"
				border="2px solid #ffffffaa"
				font="--base"
				hover-transform="translateY(-4px)"
			>
				Skip to Features
			</Link>
		</Section>
		<Section
			id="about"
			padding="80px 0 80px 0"
			background-image="linear-gradient(to bottom, #ffffff, #f7f7f7, #efefef, #e8e8e8, #e0e0e0)"
			border-top="8px dashed #ffffff"
			border-bottom="8px dashed #bdbdbd"
			sm-padding="60px 0 60px 0"
		>
			<Box
				width="100%"
				display="flex"
				flex-direction="column"
				md-width="100%"
				md-align-items="center"
				md-justify-content="center"
				md-text-align="center"
				lg-width="100%"
				margin="0px 0px 56px 0px"
				align-items="center"
			>
				<Text
					margin="0px 0px 16px 0px"
					font="--headline2"
					color="#3C3C3C"
					md-text-align="center"
					sm-font="normal 700 32px/1.2 &quot;Source Sans Pro&quot;, sans-serif"
					text-align="center"
				>
					Effortless beautiful accounting
				</Text>
				<Text
					margin="0px 0px 0px 0px"
					font="--base"
					color="#3C3C3C"
					md-text-align="center"
					text-align="center"
					max-width="80%"
				>
					From high level approvals, purchase orders and procurements all the way to the detailed line items in your books. We are here to empower you and your finance team every step of the way.
				</Text>
			</Box>
			<Box display="grid" grid-template-columns="repeat(3, 1fr)" grid-gap="32px 4%" md-grid-template-columns="1fr">
				<Box
					padding="45px 45px"
					lg-padding="45px 30px"
					md-padding="45px 45px"
					background-image="linear-gradient(to left bottom, #42a5f5, #379eec, #2b96e3, #1c8fda, #0288d1)"
					border-radius="24px"
					justify-content="flex-start"
					flex-direction="column"
					display="flex"
				>
					<Icon
						category="fa"
						icon={FaReceipt}
						margin="0 auto 30px auto"
						color="#1976D2"
						size="48px"
					/>
					<Text margin="0px 0px 18px 0px" color="#00000066" font="--headline3" lg-text-align="left">
						Purchase Orders
					</Text>
					<Text
						margin="0px 0px 0px 0px"
						color="#ffffffcc"
						font="--base"
						lg-text-align="left"
						flex="1 0 auto"
					>
						Handling purchase orders can require a team of experts.{" "}
						<br />
						<br />
						DayFive automatically handles accruals, prepayments and tricky edge cases like discounts, forex, multiple invoices, partial invoices and non-invoiced amounts so your books are always report ready.
					</Text>
				</Box>
				<Box
					padding="45px 45px"
					lg-padding="45px 30px"
					md-padding="45px 45px"
					background-image="linear-gradient(to left top, #f06292, #ef5587, #ed467b, #eb356f, #e91e63)"
					border-radius="24px"
					justify-content="flex-start"
					flex-direction="column"
					display="flex"
				>
					<Icon
						category="fa"
						icon={FaFileInvoiceDollar}
						margin="0px auto 30px auto"
						color="#C2185B"
						size="48px"
					/>
					<Text margin="0px 0px 18px 0px" color="#00000066" font="--headline3" lg-text-align="left">
						Procurements
					</Text>
					<Text
						margin="0px 0px 0px 0px"
						color="#ffffffcc"
						font="--base"
						lg-text-align="left"
						flex="1 0 auto"
					>
						Take control of your procurement pipeline with effortless quote requests and supplier collaboration. Handle multiple currencies, review supporting documents, and compare prices side-by-side.{" "}
						<br />
						<br />
						Once approved, procurements flow directly into purchase orders ensuring accuracy and easy access to all supporting documents.
					</Text>
				</Box>
				<Box
					padding="45px 45px"
					lg-padding="45px 30px"
					md-padding="45px 45px"
					background-image="linear-gradient(to bottom, #4dd0e1, #40c7d9, #32bed1, #21b5c9, #00acc1)"
					border-radius="24px"
					justify-content="flex-start"
					flex-direction="column"
					display="flex"
				>
					<Box flex-direction="row" display="flex">
						<Icon
							category="fa"
							icon={FaUserCheck}
							margin="0px auto 30px auto"
							color="#0097A7"
							size="48px"
						/>
						<Icon
							category="fa"
							icon={FaUserCheck}
							margin="0px auto 30px auto"
							color="#0097A7"
							size="48px"
						/>
						<Icon
							category="fa"
							icon={FaUserCheck}
							margin="0px auto 30px auto"
							color="#0097A7"
							size="48px"
						/>
					</Box>
					<Text margin="0px 0px 18px 0px" color="#00000066" font="--headline3" lg-text-align="left">
						Approvals
					</Text>
					<Text
						margin="0px 0px 0px 0px"
						color="#ffffffcc"
						font="--base"
						lg-text-align="left"
						flex="1 0 auto"
					>
						Make sure only budgeted expenses get through with our team based approval system.
						<br />
						<br />
						Team leads take direct control of their accounts and team members, ensuring there is always a verifiable chain of responsibility for any expense.
					</Text>
				</Box>
			</Box>
		</Section>
		<Section
			padding="180px 0 180px 0"
			background-position="center"
			background-repeat="no-repeat"
			background-size="cover"
			background-image="url(https://s3.eu-north-1.amazonaws.com/dayfive.eu/assets/img/mountains.jpg)"
			md-padding="100px 0 100px 0"
			quarkly-title="Content-12"
		>
			<Override
				slot="SectionContent"
				flex-direction="row"
				align-items="center"
				justify-content="center"
				md-flex-direction="column"
			/>
			<Box
				min-width="100px"
				min-height="100px"
				padding="0px 80px 0px 0px"
				width="50%"
				lg-width="70%"
				md-width="100%"
				md-padding="0px 0 0px 0px"
				md-margin="0px 0px 50px 0px"
			>
				<Text margin="0px 0px 30px 0px" font="--headline2" color="white">
					End-to-End
				</Text>
				<Text margin="0px 0px 40px 0px" color="--light" font="--base">
					Modern day finance moves fast and the demands placed on the teams have never been higher. Invoice management, expense tracking, reporting and the books need to be perfect, available in real-time and ready for reporting at a moments notice.
					<br />
					<br />
					DayFive empowers finance teams with a cohesive expense management workflow that takes tedious work away, giving finance teams time to do more of the things which actually move the needle.
				</Text>
			</Box>
			<Box
				min-width="180px"
				min-height="180px"
				width="180px"
				height="180px"
				background="--color-darkL1"
				border-radius="50%"
				display="flex"
				align-items="center"
				opacity="0.8"
				justify-content="center"
				background-position="center"
				background-repeat="no-repeat"
				background-size="cover"
				background-image="url(https://s3.eu-north-1.amazonaws.com/dayfive.eu/assets/img/ball_logo_balanced.png)"
				flex-direction="column"
				md-align-self="flex-end"
			/>
		</Section>
		<Section
			box-sizing="border-box"
			lg-padding="50px 30px 50px 30px"
			id="mission"
			padding="90px 0px 100px 0px"
			quarkly-title="About"
			sm-padding="24px 0 24px 0"
			background="linear-gradient(to right top, #d16ba5, #c777b9, #ba83ca, #aa8fd8, #9a9ae1, #8aa7ec, #79b3f4, #69bff8, #52cffe, #41dfff, #46eefa, #5ffbf1)"
			justify-content="center"
		>
			<Override
				slot="SectionContent"
				md-margin="0px 16px 0px 16px"
				align-items="center"
				width="100%"
				min-width="auto"
				margin="0px 32px 0px 32px"
			/>
			<Text
				text-align="center"
				font="--base"
				opacity="0.6"
				letter-spacing="1px"
				margin="0px 0px 10px 0px"
				lg-margin="0px 0px 6px 0px"
				quarkly-title="Title"
				text-transform="uppercase"
				color="--dark"
				lg-text-align="center"
			>
				<Strong>
					Our
				</Strong>
				{" "}
				<Strong>
					Mission
				</Strong>
			</Text>
			<Text
				letter-spacing="1px"
				color="#ffffff"
				text-align="center"
				width="85%"
				lg-font="--lead"
				opacity="0.85"
				sm-font="--base"
				font="normal 300 28px/1.2 'AvenirNextCyrRegular', sans-serif"
				margin="0px 0px 0px 0px"
			>
				Accountants and finance teams deserve better.{" "}
				<br />
				<br />
				<Em
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					We are building a fully automated expense management system that simplifies and actually reduces real pain around month-end chaos, invoice chasing and stressful month ends.{" "}
				</Em>
			</Text>
		</Section>
		<Section
			id="features"
			padding="90px 0 90px 0"
			sm-padding="40px 0"
			sm-min-height="auto"
			border-top="8px dashed #bdbdbd88"
			border-bottom="8px dashed #bdbdbd88"
			display="flex"
			quarkly-title="Advantages/Features-8"
		>
			<Override
				slot="SectionContent"
				flex-direction="row"
				grid-gap="5%"
				sm-min-width="280px"
				lg-flex-wrap="wrap"
				display="flex"
			/>
			<Box
				display="flex"
				width="35%"
				flex-direction="column"
				justify-content="flex-start"
				align-items="flex-start"
				lg-width="100%"
				lg-align-items="flex-start"
				lg-margin="0px 0px 60px 0px"
				sm-margin="0px 0px 30px 0px"
				sm-padding="0px 0px 0px 0px"
				lg-flex-direction="row"
				lg-flex-wrap="wrap"
				sm-width="100%"
				md-margin="0px 0px 30px 0px"
			>
				<Text
					as="h1"
					margin="0px 0px 8px 0px"
					font="--lead"
					color="#1976D2"
					width="100%"
					md-width="100%"
					md-margin="0px 0px 16px 0px"
					md-padding="0px 0px 0px 0px"
					text-align="left"
					md-text-align="center"
					sm-text-align="left"
				>
					<Strong sm-text-align="left">
						Everything you need
					</Strong>
				</Text>
				<Text
					as="h1"
					margin="0px 0px 24px 0px"
					font="--headline2"
					color="#3C3C3C"
					width="100%"
					md-width="100%"
					md-margin="0px 0px 32px 0px"
					md-padding="0px 0px 0px 0px"
					sm-font="normal 600 40px/1.2 --fontFamily-sans"
					text-align="left"
					md-text-align="center"
					sm-text-align="left"
				>
					Empowered Finance
				</Text>
				<Text
					as="h1"
					margin="0px 0px 0px 0px"
					font="--base"
					color="#757575"
					width="100%"
					md-width="100%"
					md-margin="0px 0px 32px 0px"
					md-padding="0px 0px 0px 0px"
					text-align="left"
					md-text-align="center"
					sm-text-align="left"
				>
					Automate your expense management
				</Text>
			</Box>
			<Box
				width="60%"
				display="grid"
				grid-template-columns="repeat(2, 1fr)"
				grid-gap="48px 32px"
				lg-grid-gap="48px"
				lg-width="100%"
				sm-grid-template-columns="1fr"
				md-grid-gap="36px "
			>
				<Box margin="0px 0px 0px 0px" display="flex" flex-direction="row">
					<Icon
						display="block"
						category="md"
						icon={MdDone}
						size="20px"
						color="--primary"
						margin="2px 16px 0px 0px"
					/>
					<Box display="flex" flex-direction="column">
						<Text
							as="h1"
							margin="0px 0px 0px 0px"
							font="--base"
							color="#424242"
							width="100%"
							md-width="100%"
							text-align="left"
						>
							<Strong>
								In-depth Invoice Review
							</Strong>
						</Text>
						<Text
							as="h1"
							margin="12px 0px 0px 0px"
							font="--base"
							color="--dark"
							width="100%"
							md-width="100%"
							text-align="left"
							lg-margin="8px 0px 0px 0px"
						>
							Prevent irregularities, handle discounts, partials and multiple invoices per purchase order
						</Text>
					</Box>
				</Box>
				<Box margin="0px 0px 0px 0px" display="flex" flex-direction="row">
					<Icon
						display="block"
						category="md"
						icon={MdDone}
						size="20px"
						color="--primary"
						margin="2px 16px 0px 0px"
					/>
					<Box display="flex" flex-direction="column">
						<Text
							as="h1"
							margin="0px 0px 0px 0px"
							font="--base"
							color="#424242"
							width="100%"
							md-width="100%"
							text-align="left"
						>
							<Strong>
								Built-in CSV export
							</Strong>
						</Text>
						<Text
							as="h1"
							margin="12px 0px 0px 0px"
							font="--base"
							color="--dark"
							width="100%"
							md-width="100%"
							text-align="left"
							lg-margin="8px 0px 0px 0px"
						>
							Export all automated the detailed transactions for cross checking and reporting purposes
						</Text>
					</Box>
				</Box>
				<Box margin="0px 0px 0px 0px" display="flex" flex-direction="row">
					<Icon
						display="block"
						category="md"
						icon={MdDone}
						size="20px"
						color="--primary"
						margin="2px 16px 0px 0px"
					/>
					<Box display="flex" flex-direction="column">
						<Text
							as="h1"
							margin="0px 0px 0px 0px"
							font="--base"
							color="#424242"
							width="100%"
							md-width="100%"
							text-align="left"
						>
							<Strong>
								Direct ERP Integration
							</Strong>
						</Text>
						<Text
							as="h1"
							margin="12px 0px 0px 0px"
							font="--base"
							color="--dark"
							width="100%"
							md-width="100%"
							text-align="left"
							lg-margin="8px 0px 0px 0px"
						>
							We connect directly to Xero and handle your accruals and prepayments automatically
						</Text>
					</Box>
				</Box>
				<Box margin="0px 0px 0px 0px" display="flex" flex-direction="row">
					<Icon
						display="block"
						category="md"
						icon={MdDone}
						size="20px"
						color="--primary"
						margin="2px 16px 0px 0px"
					/>
					<Box display="flex" flex-direction="column">
						<Text
							as="h1"
							margin="0px 0px 0px 0px"
							font="--base"
							color="#424242"
							width="100%"
							md-width="100%"
							text-align="left"
						>
							<Strong>
								Notifications
							</Strong>
						</Text>
						<Text
							as="h1"
							margin="12px 0px 0px 0px"
							font="--base"
							color="--dark"
							width="100%"
							md-width="100%"
							text-align="left"
							lg-margin="8px 0px 0px 0px"
						>
							Get notified when changes occur and when your action is needed
						</Text>
					</Box>
				</Box>
				<Box margin="0px 0px 0px 0px" display="flex" flex-direction="row">
					<Icon
						display="block"
						category="md"
						icon={MdDone}
						size="20px"
						color="--primary"
						margin="2px 16px 0px 0px"
					/>
					<Box display="flex" flex-direction="column">
						<Text
							as="h1"
							margin="0px 0px 0px 0px"
							font="--base"
							color="#424242"
							width="100%"
							md-width="100%"
							text-align="left"
						>
							<Strong>
								Auto Accruals and Prepayments
							</Strong>
						</Text>
						<Text
							as="h1"
							margin="12px 0px 0px 0px"
							font="--base"
							color="--dark"
							width="100%"
							md-width="100%"
							text-align="left"
							lg-margin="8px 0px 0px 0px"
						>
							Accruals and prepayments are scheduled, calculated and automatically inserted into your books. Saving you valuable time on manual processes
						</Text>
					</Box>
				</Box>
				<Box margin="0px 0px 0px 0px" display="flex" flex-direction="row">
					<Icon
						display="block"
						category="md"
						icon={MdDone}
						size="20px"
						color="--primary"
						margin="2px 16px 0px 0px"
					/>
					<Box display="flex" flex-direction="column">
						<Text
							as="h1"
							margin="0px 0px 0px 0px"
							font="--base"
							color="#424242"
							width="100%"
							md-width="100%"
							text-align="left"
						>
							<Strong>
								Procurements
							</Strong>
						</Text>
						<Text
							as="h1"
							margin="12px 0px 0px 0px"
							font="--base"
							color="--dark"
							width="100%"
							md-width="100%"
							text-align="left"
							lg-margin="8px 0px 0px 0px"
						>
							Streamline your requisition process by comparing procurement quotes
						</Text>
					</Box>
				</Box>
				<Box margin="0px 0px 0px 0px" display="flex" flex-direction="row">
					<Icon
						display="block"
						category="md"
						icon={MdDone}
						size="20px"
						color="--primary"
						margin="2px 16px 0px 0px"
					/>
					<Box display="flex" flex-direction="column">
						<Text
							as="h1"
							margin="0px 0px 0px 0px"
							font="--base"
							color="#424242"
							width="100%"
							md-width="100%"
							text-align="left"
						>
							<Strong>
								Repeating Purchase Orders
							</Strong>
						</Text>
						<Text
							as="h1"
							margin="12px 0px 0px 0px"
							font="--base"
							color="--dark"
							width="100%"
							md-width="100%"
							text-align="left"
							lg-margin="8px 0px 0px 0px"
						>
							Annual, Bi-annual, Quarterly, Monthly are all supported
						</Text>
					</Box>
				</Box>
				<Box margin="0px 0px 0px 0px" display="flex" flex-direction="row">
					<Icon
						display="block"
						category="md"
						icon={MdDone}
						size="20px"
						color="--primary"
						margin="2px 16px 0px 0px"
					/>
					<Box display="flex" flex-direction="column">
						<Text
							as="h1"
							margin="0px 0px 0px 0px"
							font="--base"
							color="#424242"
							width="100%"
							md-width="100%"
							text-align="left"
						>
							<Strong>
								Teams and Approvals
							</Strong>
						</Text>
						<Text
							as="h1"
							margin="12px 0px 0px 0px"
							font="--base"
							color="--dark"
							width="100%"
							md-width="100%"
							text-align="left"
							lg-margin="8px 0px 0px 0px"
						>
							Our simple permission setup ensures teams stay accountable for their expenses, thanks to a transparent chain of accountability
						</Text>
					</Box>
				</Box>
			</Box>
		</Section>
		<Section
			id="integrations"
			padding="90px 0 90px 0"
			sm-padding="60px 0 60px 0"
			background="rgba(0, 0, 0, 0) linear-gradient(120deg,white 0%,--color-lightD2 100%) 0% 0% /auto repeat scroll padding-box"
			color="--dark"
			md-padding="60px 0 60px 0"
			quarkly-title="Advantages/Features-27"
		>
			<Override slot="SectionContent" max-width="1220px" md-align-items="center" sm-min-width="280px" />
			<Box
				border-radius="24px"
				margin="0px 0px 80px 0px"
				md-margin="0px 0px 40px 0px"
				width="55%"
				md-width="80%"
				sm-width="100%"
			>
				<Text
					md-text-align="center"
					margin="0px 0px 16px 0px"
					font="--base"
					color="#0097A7"
					letter-spacing="1px"
				>
					AVAILABLE PLATFORMS
				</Text>
				<Text
					color="#3C3C3C"
					md-text-align="center"
					margin="0px 0px 0px 0px"
					font="--headline2"
					width="100%"
					letter-spacing="-1px"
					lg-width="100%"
					md-font="--headline3"
				>
					INTEGRATES WITH
				</Text>
			</Box>
			<Box
				lg-flex-wrap="wrap"
				display="grid"
				grid-template-columns="repeat(4, 1fr)"
				grid-gap="16px"
				md-grid-template-columns="repeat(2, 1fr)"
				md-grid-gap="36px"
				sm-grid-template-columns="repeat(1, 1fr)"
				sm-grid-gap="8px"
			>
				<Box
					sm-margin="0px 0px 30px 0px"
					sm-width="100%"
					display="flex"
					flex-direction="column"
					justify-content="space-between"
					md-align-items="center"
				>
					<Text
						margin="0px 0px 18px 0px"
						color="#0097A7"
						font="--headline5"
						lg-text-align="left"
						md-font="--lead"
						md-text-align="center"
					>
						<Strong line-height="30px">
							Available Now
						</Strong>
					</Text>
					<Box display="flex" flex-direction="row">
						<Text
							margin="0px 0px 18px 0px"
							color="#424242"
							font="--headline2"
							lg-text-align="left"
							md-font="--lead"
							md-text-align="center"
						>
							Xero
						</Text>
						<Box margin-top="16px">
							<Link
								font="--base"
								text-decoration-line="initial"
								margin="0px 0px 0px 16px"
								background="#ffffff"
								border="2px solid #0097A7"
								border-radius="8px"
								href="https://apps.xero.com/us/app/dayfive"
								color="#0097A7"
								padding="6px 12px 7px 12px"
							>
								App Store
							</Link>
						</Box>
					</Box>
				</Box>
				<Box
					sm-margin="0px 0px 30px 0px"
					sm-width="100%"
					display="flex"
					flex-direction="column"
					justify-content="space-between"
					md-align-items="center"
				>
					<Text
						margin="0px 0px 18px 0px"
						color="#9e9e9e"
						font="--headline5"
						lg-text-align="left"
						md-font="--lead"
						md-text-align="center"
					>
						Coming Soon
					</Text>
					<Text
						margin="0px 0px 18px 0px"
						color="#424242"
						font="--headline3"
						lg-text-align="left"
						md-font="--lead"
						md-text-align="center"
					>
						Quick Books Online
					</Text>
				</Box>
				<Box
					sm-margin="0px 0px 30px 0px"
					sm-width="100%"
					display="flex"
					flex-direction="column"
					justify-content="space-between"
					md-align-items="center"
				>
					<Text
						margin="0px 0px 18px 0px"
						color="#9e9e9e"
						font="--headline4"
						lg-text-align="left"
						md-font="--lead"
						md-text-align="center"
					>
						Coming Soon
					</Text>
					<Text
						margin="0px 0px 18px 0px"
						color="#424242"
						font="--headline3"
						lg-text-align="left"
						md-font="--lead"
						md-text-align="center"
					>
						NetSuite
					</Text>
				</Box>
				<Box
					sm-margin="0px 0px 30px 0px"
					sm-width="100%"
					display="flex"
					flex-direction="column"
					justify-content="space-between"
					md-align-items="center"
				>
					<Text
						margin="0px 0px 18px 0px"
						color="#9e9e9e"
						font="--headline4"
						lg-text-align="left"
						md-font="--lead"
						md-text-align="center"
					>
						Coming Soon
					</Text>
					<Text
						margin="0px 0px 18px 0px"
						color="#424242"
						font="--headline3"
						lg-text-align="left"
						md-font="--lead"
						md-text-align="center"
					>
						Sage
					</Text>
				</Box>
			</Box>
		</Section>
		<Section padding="80px 0 80px 0" quarkly-title="Customers" lg-padding="50px 0 50px 0" justify-content="center">
			<Override
				slot="SectionContent"
				min-width="auto"
				margin="0px 32px 0px 32px"
				align-items="center"
				width="100%"
				md-margin="0px 16px 0px 16px"
			/>
			<Text
				color="#E91E63"
				text-align="center"
				lg-margin="0px 0px 6px 0px"
				text-transform="uppercase"
				lg-text-align="center"
				quarkly-title="Title"
				font="--base"
				margin="0px 0px 10px 0px"
				letter-spacing="1px"
				opacity="0.6"
			>
				They trust us
			</Text>
			<Text
				text-align="center"
				lg-text-align="center"
				sm-margin="0px 0px 48px 0px"
				sm-font="--headline3"
				md-font="--headline3"
				font="--headline2"
				margin="0px 0px 64px 0px"
				color="#3C3C3C"
			>
				Our Customers
			</Text>
			<Box
				lg-grid-template-columns="repeat(5, 1fr)"
				sm-grid-template-columns="1fr"
				display="grid"
				width="100%"
				grid-gap="32px"
				grid-template-columns="repeat(5, 1fr)"
			>
				<Box
					sm-align-items="center"
					sm-margin="0px 0px 0px 20px"
					lg-grid-column="1 / span 2"
					sm-grid-column="auto / auto"
					sm-display="flex"
				>
					<Box
						min-width="84px"
						min-height="84px"
						width="84px"
						height="84px"
						background="--color-darkL1"
						border-radius="50%"
						display="flex"
						align-items="center"
						opacity="0.8"
						justify-content="center"
						margin="auto"
						background-position="center"
						background-repeat="no-repeat"
						background-size="cover"
						background-image="url(https://s3.eu-north-1.amazonaws.com/dayfive.eu/assets/img/rhosigns_logo.png)"
						md-align-self="flex-end"
					/>
					<Text
						md-margin="16px 0px 0px 0px"
						sm-margin="0px 0px 0px 0px"
						font="--base"
						color="--darkL2"
						opacity="0.6"
						lg-text-align="center"
						text-align="center"
					>
						Rhosigns Neon
					</Text>
				</Box>
				<Box
					sm-align-items="center"
					sm-margin="0px 0px 0px 20px"
					lg-grid-column="3 / span 2"
					sm-grid-column="auto / auto"
					sm-display="flex"
				>
					<Box
						min-width="84px"
						min-height="84px"
						width="84px"
						height="84px"
						background="--color-darkL1"
						border-radius="50%"
						display="flex"
						align-items="center"
						opacity="0.8"
						justify-content="center"
						margin="auto"
						background-position="center"
						background-repeat="no-repeat"
						background-size="cover"
						background-image="url(https://s3.eu-north-1.amazonaws.com/dayfive.eu/assets/img/cpd_logo.png)"
						md-align-self="flex-end"
					/>
					<Text
						text-align="center"
						md-margin="16px 0px 0px 0px"
						sm-margin="0px 0px 0px 0px"
						font="--base"
						color="--darkL2"
						opacity="0.6"
						lg-text-align="center"
					>
						CPD Holdings
					</Text>
				</Box>
				<Box
					lg-grid-column="5 / span 2"
					sm-grid-column="auto / auto"
					sm-display="flex"
					sm-align-items="center"
					sm-margin="0px 0px 0px 20px"
				>
					<Box
						min-width="84px"
						min-height="84px"
						width="84px"
						height="84px"
						background="white"
						display="flex"
						align-items="center"
						opacity="0.8"
						justify-content="center"
						margin="auto"
						background-position="center"
						background-repeat="no-repeat"
						background-size="contain"
						background-image="url(https://s3.eu-north-1.amazonaws.com/dayfive.eu/assets/img/mimosa_trust_logo.jpeg)"
						md-align-self="flex-end"
					/>
					<Text
						font="--base"
						color="--darkL2"
						opacity="0.6"
						lg-text-align="center"
						text-align="center"
						md-margin="16px 0px 0px 0px"
						sm-margin="0px 0px 0px 0px"
					>
						Mimosa Trust
					</Text>
				</Box>
				<Box
					lg-grid-column="2 / span 2"
					sm-grid-column="auto / auto"
					sm-display="flex"
					sm-align-items="center"
					sm-margin="0px 0px 0px 20px"
				>
					<Box
						min-width="84px"
						min-height="84px"
						width="84px"
						height="84px"
						background="--color-darkL1"
						border-radius="50%"
						display="flex"
						align-items="center"
						opacity="0.8"
						justify-content="center"
						margin="auto"
						background-position="center"
						background-repeat="no-repeat"
						background-size="cover"
						background-image="url(https://s3.eu-north-1.amazonaws.com/dayfive.eu/assets/img/jicmail_logo.png)"
						md-align-self="flex-end"
					/>
					<Text
						color="--darkL2"
						opacity="0.6"
						lg-text-align="center"
						text-align="center"
						md-margin="16px 0px 0px 0px"
						sm-margin="0px 0px 0px 0px"
						font="--base"
					>
						Jicmail
					</Text>
				</Box>
				<Box
					lg-grid-column="2 / span 2"
					sm-grid-column="auto / auto"
					sm-display="flex"
					sm-align-items="center"
					sm-margin="0px 0px 0px 20px"
				>
					<Box
						min-width="84px"
						min-height="84px"
						width="84px"
						height="84px"
						background="--color-darkL1"
						border-radius="50%"
						display="flex"
						align-items="center"
						opacity="0.8"
						justify-content="center"
						margin="auto"
						background-position="center"
						background-repeat="no-repeat"
						background-size="cover"
						background-image="url(https://s3.eu-north-1.amazonaws.com/dayfive.eu/assets/img/overviewfx_logo.png)"
						md-align-self="flex-end"
					/>
					<Text
						color="--darkL2"
						opacity="0.6"
						lg-text-align="center"
						text-align="center"
						md-margin="16px 0px 0px 0px"
						sm-margin="0px 0px 0px 0px"
						font="--base"
					>
						OverviewFX
					</Text>
				</Box>
			</Box>
		</Section>
		<Section
			id="pricing"
			padding="120px 0 0 0"
			lg-margin="0 0 0 0"
			background-image="radial-gradient(18% 28% at 24% 50%, #03A9F4FF 0%, #073AFF00 100%),radial-gradient(18% 28% at 18% 71%, #FFFFFF59 6%, #073AFF00 100%),radial-gradient(70% 53% at 36% 76%, #03A9F4FF 0%, #073AFF00 100%),radial-gradient(42% 53% at 15% 94%, #FFFFFFFF 7%, #073AFF00 100%),radial-gradient(42% 53% at 34% 72%, #FFFFFFFF 7%, #073AFF00 100%),radial-gradient(18% 28% at 35% 87%, #FFFFFFFF 7%, #073AFF00 100%),radial-gradient(31% 43% at 7% 98%, #0097A7FF 0%, #073AFF00 100%),radial-gradient(21% 37% at 72% 23%, #D16BA59C 24%, #073AFF00 100%),radial-gradient(35% 56% at 91% 74%, #E91E63F5 9%, #073AFF00 100%),radial-gradient(74% 86% at 67% 38%, #E91E63F5 0%, #073AFF00 100%),linear-gradient(125deg, #1976D2FF 1%, #0097A7FF 51%, #C2185BFF 100%)"
			lg-padding="80px 0 80px 0"
			quarkly-title="Price-8"
		>
			<Override
				slot="SectionContent"
				align-items="center"
				justify-content="flex-start"
				max-width="none"
				min-width="none"
				width="100%"
			/>
			<Box
				min-width="300px"
				max-width="1280px"
				display="flex"
				flex-direction="column"
				align-items="center"
				justify-content="flex-start"
				lg-padding="0px 20px 0px 20px"
			>
				<Text
					margin="0px 0px 20px 0px"
					font="normal 500 20px/1.5 --fontFamily-sansHelvetica"
					color="#ffffff88"
					lg-margin="0px 0px 20px 0px"
					text-align="center"
				>
					Pricing
				</Text>
				<Text
					margin="0px 0px 20px 0px"
					font="normal 600 46px/1.2 --fontFamily-sans"
					text-align="center"
					md-margin="0px 0px 50px 0px"
					align-self="center"
					color="--light"
					sm-margin="0px 0px 30px 0px"
				>
					Empower your finances today
				</Text>
				<Text
					margin="0px 0px 70px 0px"
					text-align="center"
					font="normal 300 20px/1.5 --fontFamily-sansTrebuchet"
					width="600px"
					align-self="center"
					md-width="100%"
					color="#ffffffcc"
					md-margin="0px 0px 60px 0px"
					sm-margin="0px 0px 40px 0px"
				>
					All our plans come with access to our customer support team, extensive knowledge base and all DayFive features. Pricing is per organisation, invite your whole team.
				</Text>
				<Text
					margin="0px 0px 20px 0px"
					text-align="center"
					font="normal 300 20px/1.5 --fontFamily-sansTrebuchet"
					width="600px"
					align-self="center"
					md-width="100%"
					color="#ffffffcc"
					md-margin="0px 0px 60px 0px"
					sm-margin="0px 0px 40px 0px"
				>
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							We also support different pricing depending on your location.{" "}
							<br />
							Pricing is offered in GBP, USD, EUR and ZAR.
							<br />
						</Em>
					</Strong>
				</Text>
				<Text
					margin="0px 0px 70px 0px"
					text-align="center"
					font="normal 300 14px/1.5 --fontFamily-sansTrebuchet"
					width="600px"
					align-self="center"
					md-width="100%"
					color="#ffffffcc"
					md-margin="0px 0px 60px 0px"
					sm-margin="0px 0px 40px 0px"
				>
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							By default all accounts are limited to 10 users. Get in contact for customised options.
						</Em>
					</Strong>
				</Text>
				<Box
					display="flex"
					margin="0px 120px -180px 120px"
					md-flex-direction="column"
					border-width="1px"
					grid-template-columns="repeat(2, 1fr)"
					lg-align-items="stretch"
					lg-display="flex"
					lg-flex-direction="row"
					lg-grid-gap="36px"
					lg-justify-content="flex-start"
					lg-margin="0px 120px -250px 120px"
					lg-width="100%"
					sm-margin="0px 0px -250px 0px"
				>
					<Box
						min-width="100px"
						min-height="100px"
						padding="40px 40px 40px 40px"
						border-width="1px"
						border-style="solid"
						border-color="#bec3ca"
						border-radius="15px"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						background="--color-light"
						md-margin="0px 0px 0px 0px"
						position="relative"
						z-index="2"
						margin="0px 15px 0px 0px"
						box-shadow="--l"
						sm-margin="0px 0px 0px 0px"
						sm-padding="30px 25px 30px 25px"
						lg-margin="0px 0px 0px 0px"
					>
						<Box min-width="100px" min-height="100px">
							<Text
								margin="0px 0px 8px 0px"
								font="normal 500 20px/1.5 --fontFamily-sansHelvetica"
								color="#03A9F4"
								lg-margin="0px 0px 20px 0px"
								sm-margin="0px 0px 10px 0px"
							>
								Monthly Plan
							</Text>
							<Text margin="0px 0px 10px 0px" font="normal 400 18px/1.5 --fontFamily-sans" color="#4f5457">
								<Span
									font="normal 700 46px/1.2 --fontFamily-sans"
									overflow-wrap="normal"
									word-break="normal"
									white-space="normal"
									text-indent="0"
									text-overflow="clip"
									hyphens="manual"
									user-select="auto"
									pointer-events="auto"
									color="--darkL1"
								>
									$100
								</Span>
								{" "}/ month
							</Text>
						</Box>
						<Link
							href="https://app.dayfive.eu/login"
							background="#03A9F4"
							margin-top="30px"
							font="normal 400 17px/1.5 --fontFamily-sansHelvetica"
							text-decoration-line="initial"
							color="--light"
							border-color="--color-light"
							border-radius="4px"
							padding="12px"
							text-align="center"
						>
							Get started today
						</Link>
					</Box>
					<Box
						min-width="100px"
						min-height="100px"
						padding="40px 40px 40px 40px"
						border-width="1px"
						border-style="solid"
						border-color="#bec3ca"
						border-radius="15px"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						background="--color-light"
						position="relative"
						z-index="2"
						margin="0px 0px 0px 15px"
						box-shadow="--l"
						md-margin="0px 0px 0px 0"
						sm-padding="30px 25px 30px 25px"
						lg-margin="0px 0px 0px 0px"
					>
						<Box min-width="100px" min-height="100px">
							<Text
								margin="0px 0px 8px 0px"
								font="normal 500 20px/1.5 --fontFamily-sansHelvetica"
								color="#1976D2"
								lg-margin="0px 0px 20px 0px"
								sm-margin="0px 0px 10px 0px"
							>
								Annual Plan
							</Text>
							<Text margin="0px 0px 10px 0px" font="normal 400 18px/1.5 --fontFamily-sans" color="#4f5457">
								<Span
									font="normal 700 46px/1.2 --fontFamily-sans"
									overflow-wrap="normal"
									word-break="normal"
									white-space="normal"
									text-indent="0"
									text-overflow="clip"
									hyphens="manual"
									user-select="auto"
									pointer-events="auto"
									color="--darkL1"
								>
									$1000
								</Span>
								{" "}/ Annual (
								<Em>
									2 months free
								</Em>
								)
							</Text>
						</Box>
						<Link
							href="https://app.dayfive.eu/login"
							background="#1976D2"
							margin-top="30px"
							font="normal 400 17px/1.5 --fontFamily-sansHelvetica"
							text-decoration-line="initial"
							color="--light"
							border-color="--color-light"
							border-radius="4px"
							padding="12px"
							text-align="center"
						>
							Get started today
						</Link>
					</Box>
				</Box>
			</Box>
			<Box
				width="100%"
				background="#ffffff"
				padding="250px 0px 120px 0px"
				display="flex"
				flex-direction="column"
				align-items="center"
				justify-content="flex-start"
				lg-padding="250px 20px 120px 20px"
			>
				<Box
					min-width="280px"
					min-height="10px"
					margin="0px 140px 0px 140px"
					display="flex"
					justify-content="space-between"
					align-items="center"
					padding="25px 25px 25px 25px"
					border-width="1px"
					border-style="solid"
					border-color="#bec3ca"
					border-radius="15px"
					lg-margin="40px 0 0px 0"
					sm-flex-direction="column"
					md-flex-direction="column"
					md-align-items="stretch"
					max-width="1280px"
				>
					<Box
						min-width="10px"
						min-height="10px"
						width="70%"
						sm-width="100%"
						sm-text-align="center"
						md-flex-direction="column"
					>
						<Text margin="0px 0px 10px 0px" font="normal 600 22px/1.2 --fontFamily-sans" color="#1976D2">
							Specials & Deals
						</Text>
						<Text
							margin="0px 0px 0px 0px"
							font="normal 400 17px/1.5 --fontFamily-sansHelvetica"
							color="#4f5457"
							padding="0px 70px 0px 0px"
							md-padding="0px 0px 0px 0px"
							md-margin="0px 0px 20px 0px"
						>
							Contact our sales team today to learn more about pricing, increasing user limits or reselling to take advantage of available offers.
						</Text>
					</Box>
					<Link
						font="--base"
						text-decoration-line="initial"
						margin="0px 0px 0px 16px"
						background="#ffffff"
						border="2px solid #0097A7"
						border-radius="4px"
						md-margin="0px 0px 0px 14px"
						href="https://calendar.app.google/fQpVz66cTdDvWA7E8"
						color="#1976D2"
						border-color="#1976D2"
						padding="6px 12px 7px 12px"
					>
						Book a call
					</Link>
				</Box>
			</Box>
		</Section>
		<Section padding="50px 0 50px 0" quarkly-title="Footer-3">
			<Override slot="SectionContent" sm-align-items="center" />
			<Box
				display="grid"
				grid-template-columns="repeat(3, 1fr)"
				grid-gap="16px 24px"
				align-self="center"
				margin="0px 0px 40px 0px"
			>
				<LinkBox href="https://www.instagram.com/app.dayfive/">
					<Icon
						category="fa"
						icon={FaInstagram}
						size="24px"
						color="#5a5d64"
						hover-color="--dark"
						transition="background-color 1s ease 0s"
					/>
				</LinkBox>
				<LinkBox href="https://www.linkedin.com/company/appdayfive/">
					<Icon
						category="fa"
						icon={FaLinkedin}
						size="24px"
						color="#5a5d64"
						hover-color="--dark"
						transition="background-color 1s ease 0s"
					/>
				</LinkBox>
				<LinkBox href="https://www.facebook.com/share/14NRcGKmQnW/">
					<Icon
						category="fa"
						icon={FaFacebook}
						size="24px"
						color="#5a5d64"
						hover-color="--dark"
						transition="background-color 1s ease 0s"
					/>
				</LinkBox>
			</Box>
			<Box display="flex" flex-direction="column" align-items="center" margin="0px 0px 45px 0px">
				<Box
					md-margin="0px 0px 0px 0px"
					display="grid"
					md-justify-content="center"
					md-align-items="center"
					justify-content="center"
					sm-flex-wrap="wrap"
					grid-template-columns="repeat(4, 1fr)"
					grid-gap="16px 24px"
					sm-grid-template-columns="1fr"
				>
					<Link
						color="#5a5d64"
						margin="0px 6px 0px 0px"
						href="#"
						font="normal 400 18px/1.5 --fontFamily-sans"
						text-decoration-line="initial"
						hover-color="--darkL1"
						transition="background-color 0.1s ease 0s"
						sm-text-align="center"
						md-margin="0px 0 0px 0px"
					>
						Home
					</Link>
					<Link
						margin="0px 6px 0px 6px"
						href="https://calendar.app.google/fQpVz66cTdDvWA7E8"
						font="normal 400 18px/1.5 --fontFamily-sans"
						text-decoration-line="initial"
						color="#5a5d64"
						hover-color="--darkL1"
						transition="background-color 0.1s ease 0s"
						sm-text-align="center"
						md-margin="0px 0 0px 6px"
					>
						Contact
					</Link>
					<Link
						margin="0px 6px 0px 6px"
						href="https://dayfive.eu/Legal/PrivacyPolicy.html"
						font="normal 400 18px/1.5 --fontFamily-sans"
						text-decoration-line="initial"
						color="#5a5d64"
						hover-color="--darkL1"
						transition="background-color 0.1s ease 0s"
						sm-text-align="center"
						md-margin="0px 0 0px 6px"
					>
						Privacy Policy
					</Link>
					<Link
						margin="0px 6px 0px 6px"
						href="https://dayfive.eu/Legal/TermsConditions.html"
						font="normal 400 18px/1.5 --fontFamily-sans"
						text-decoration-line="initial"
						color="#5a5d64"
						hover-color="--darkL1"
						transition="background-color 0.1s ease 0s"
						sm-text-align="center"
						md-margin="0px 0 0px 6px"
					>
						Terms and Conditions
					</Link>
				</Box>
			</Box>
			<Text
				margin="0 0px 0 0px"
				font="--base"
				color="#5a5d64"
				text-align="center"
				sm-display="flex"
				sm-flex-wrap="wrap"
			>
				© 2025 DayFive Ltd. All rights reserved.
			</Text>
		</Section>
	</Theme>;
});